import { styled } from '@linaria/react';
import { colors, fonts, layout, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const TriggerButton = styled.button`
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
  background: ${colors.white};
  border: 1px solid ${colors.borderGrey};
  border-radius: ${layout.borderRadius};
  padding: 8px 12px;
  cursor: pointer;
  text-align: left;
  font-family: ${fonts.body};
  outline: none;
  transition: border-color 0.15s ease;

  &:focus {
    border-color: ${colors.primary};
  }
`;

export const TriggerLabel = styled.span`
  font-size: ${fonts.size.xs};
  font-weight: ${fonts.weight.semiBold};
  color: ${colors.fontSecondary};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const TriggerValue = styled.span`
  font-size: ${fonts.size.sm};
  color: ${colors.fontPrimary};
`;

export const Dropdown = styled.div<{ $asInline?: boolean; $withShadow?: boolean }>`
  position: ${({ $asInline }) => ($asInline ? 'relative' : 'absolute')};
  top: ${({ $asInline }) => ($asInline ? '0' : 'calc(100% + 4px)')};
  left: 0;
  z-index: ${layout.zIndexDropdown};
  background: ${colors.white};
  border-radius: ${layout.borderRadiusLg};
  box-shadow: ${({ $asInline, $withShadow }) =>
    !$asInline || $withShadow ? layout.shadow : 'none'};
  padding: ${space[5]};
  min-width: 280px;
`;

export const CounterRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space[5]};
  padding: ${space[4]} 0;

  & + & {
    border-top: 1px solid ${colors.borderGreyLighter};
  }
`;

export const CounterLabel = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.bold};
  color: ${colors.fontPrimary};
`;
